export const LOGIN_VALIDATION_MESSAGES = {
  USERNAME_REQUIRED: 'Username is required.',
  EMAIL_REQUIRED: 'Email Address is required.',
  PWD_REQUIRED: 'Password is required.',
  PWD_MINLENGTH: 'Minimum acceptable length is 14 characters.',
  INVALID_EMAIL: 'Invalid email format.',
  MAX_50: 'Must be less than 50 characters.',
  NO_MATCH: 'The confirmation password does not match the new password.'
}

export const COMMON_REGEX = {
  EMAIL: /\S+@\S+\.\S+/,
};

export const PWD_MIN_LENGTH = 14;